import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {BankDetails} from "features/bankDetails/models";

export interface IBankDetails {
  bankDetails: BankDetails | any;
  loading: boolean;
  isSaveSuccess: boolean;
}

const initial: IBankDetails = {
  bankDetails: null,
  loading: false,
  isSaveSuccess: false,
};

export const BankInformationSlice = createSlice({
  name: "bankDetails",
  initialState: initial,

  reducers: {
    changeBankDetails: (
      state,
      action: PayloadAction<{ id: string; value: string }>
    ) => {
      state.bankDetails = {
        ...state.bankDetails,
        [action.payload.id]: action.payload.value,
      };
    },

    saveBankDetailsRequest: (state) => {
      state.loading = true;
      state.isSaveSuccess = false;
    },
    saveBankDetailsSuccess: (state) => {
      state.loading = false;
      state.isSaveSuccess = true;
    },
    saveBankDetailsFailure: (state) => {
      state.loading = false;
      state.isSaveSuccess = false;
    },
    getBankDetailsRequest: (state) => {
      state.loading = true;
    },
    getBankDetailsSuccess: (state, action) => {
      if (action.payload) {
        state.bankDetails = {
          accountName: action.payload?.account_name || "",
          typeOfAccount: action.payload?.account_type || "",
          accountNumber: action.payload?.account_no || "",
          bankName: action.payload?.bank_name || "",
          bankCode: action.payload?.bank_code || "",
          branchName: action.payload?.branch_name || "",
          branchCode: action.payload?.branch_code || "",
          swiftCode: action.payload?.swift_code || "",
          submitDate: action.payload?.submit_date || ""
        };
      }
      state.loading = false;
    },
    getBankDetailsFailure: (state) => {
      state.loading = false;
    },
    resetBankDetails: (state) => {
      state.isSaveSuccess = false;
    },
  },
});

export const {
  changeBankDetails,
  saveBankDetailsRequest,
  saveBankDetailsSuccess,
  saveBankDetailsFailure,
  getBankDetailsRequest,
  getBankDetailsSuccess,
  getBankDetailsFailure,
  resetBankDetails,
} = BankInformationSlice.actions;

export default BankInformationSlice.reducer;
